<template>
    <section v-if="pageLoader">
        <div class="page-loader">{{ $t("loading.loading") }}</div>
    </section>
    <section v-else-if="!userIsEmpty('user')" class="events">
        <h1 class="heading">
            <div class="container-mobile">
                {{ $t("events.events") }}
            </div>
        </h1>
        <div class="info-block container-mobile">
            <div v-if="!eventsIsEmpty('events')" class="user-list">
                <div
                    v-for="(event, index) in events"
                    :ref="'element' + index"
                    class="user-item"
                >
                    <router-link
                        v-if="event.user"
                        :to="'/profile/' + event.user.id"
                        :style="{
                            'background-image': event.user.avatar
                                ? 'url(' + event.user.avatar + ')'
                                : '',
                        }"
                        class="user-item-avatar"
                        :class="{ 'no-avatar': !event.user.avatar }"
                    ></router-link>
                    <div
                        v-else-if="event.event_type == 7"
                        class="user-item-avatar anonymous"
                    ></div>
                    <router-link
                        v-else
                        :to="'/profile/' + user.id"
                        :style="{
                            'background-image': user.avatar
                                ? 'url(' + user.avatar + ')'
                                : '',
                        }"
                        class="user-item-avatar"
                        :class="{ 'no-avatar': !user.avatar }"
                    ></router-link>

                    <div class="user-item-info">
                        <!-- <component v-bind:is="formatText(event)"></component> -->

                        <div v-if="event.event_type == 1">
                            <div class="user-item-subtitle">
                                {{ $t("balance.user") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>
                            <div class="user-item-subtitle">
                                {{ $t("events.likedYourPicture") }}
                            </div>
                            <div v-if="event.extra && event.extra.image" class="events-img-wrapper">
                                <img
                                    :src="event.extra.image"
                                    alt="Photo"
                                    style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                        object-position: center;
                                    "
                                />
                            </div>
                            <div v-else class="events-img-empty">
                                <i>{{ $t("events.photoDeleted") }}</i>
                            </div>
                        </div>

                        <div v-if="event.event_type == 2">
                            <div class="user-item-subtitle">
                                {{ $t("balance.user") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>
                            <div class="user-item-subtitle">
                                {{ $t("events.likedYourPuzzle") }}
                            </div>
                        </div>

                        <div v-if="event.event_type == 3">
                            <div class="user-item-subtitle">
                                {{ $t("balance.user") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>
                            <div class="user-item-subtitle">
                                {{ $t("events.commentYourPicture") }}
                            </div>
                            <div v-if="event.extra && event.extra.photo && event.extra.photo.image" class="events-img-wrapper">
                                <img
                                    :src="event.extra.photo.image"
                                    alt="Puzzle"
                                    style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                        object-position: center;
                                    "
                                />
                            </div>
                            <div v-else class="events-img-empty">
                                <i>{{ $t("events.photoDeleted") }}</i>
                            </div>
                        </div>

                        <div v-if="event.event_type == 4">
                            <div class="user-item-subtitle">
                                {{ $t("balance.user") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>

                            <div class="user-item-subtitle">
                                {{ $t("events.offersFriends") }}
                            </div>
                        </div>

                        <div v-if="event.event_type == 5">
                            <div class="user-item-subtitle">
                                {{ $t("balance.user") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>

                            <div class="user-item-subtitle">
                                {{ $t("events.unfriendedYou") }}
                            </div>
                        </div>

                        <div v-if="event.event_type == 6">
                            <div class="user-item-subtitle">
                                {{ $t("balance.user") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>
                            <div class="user-item-subtitle">
                                {{ $t("events.gaveYouGift") }}
                            </div>
                            <div v-if="event.extra && event.extra.image" class="events-img-wrapper">
                                <img
                                    :src="event.extra.image"
                                    alt="Image"
                                    style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                        object-position: center;
                                    "
                                />
                            </div>
                            <div v-else class="events-img-empty">
                                <i>{{ $t("events.imageDeleted") }}</i>
                            </div>
                        </div>

                        <div v-if="event.event_type == 7">
                            <div v-if="event.extra && event.extra.image" class="events-img-list">
                                <div
                                    @click="
                                        $modal.show('my-gifts', {
                                            id: user.id,
                                            gift: {
                                                id: event.extra.id,
                                                gift_id: event.extra.gift_id,
                                                message: event.extra.message,
                                                from_user: event.user,
                                                activated:
                                                    event.extra.activated,
                                                image: event.extra.image,
                                            },
                                            eventId: event.id,
                                        })
                                    "
                                    class="events-gift-wrapper"
                                >
                                    <img
                                        :src="event.extra.image"
                                        alt=""
                                        class="events-gift-img"
                                        style="
                                            width: 100%;
                                            height: 100%;
                                            object-fit: cover;
                                            object-position: center;
                                        "
                                    />
                                </div>
                            </div>
                            <div v-else class="events-img-empty">
                                <i>
                                    {{
                                        $t("events.imagesDeletedUnavailable")
                                    }}</i
                                >
                            </div>
                        </div>

                        <div v-if="event.event_type == 8">
                            <div class="user-item-subtitle">
                                {{ $t("events.friend") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>
                            <div class="user-item-subtitle">
                                {{ $t("events.birthdayToday") }}
                            </div>
                        </div>

                        <div v-if="event.event_type == 9">
                            <div class="user-item-subtitle">
                                {{ $t("events.friend") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>
                            <div class="user-item-subtitle">
                                {{ $t("events.addedNewPhotos") }}
                            </div>
                            <div v-if="event.extra && event.extra[0] && event.extra[0].image" class="events-img-wrapper">
                                <img
                                    :src="event.extra[0].image"
                                    alt="Image"
                                    style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                        object-position: center;
                                    "
                                />
                            </div>
                            <div v-else class="events-img-empty">
                                <i>{{ $t("events.photoDeleted") }}</i>
                            </div>
                        </div>

                        <div
                            v-if="
                                event.event_type == 10 || event.event_type == 22
                            "
                        >
                            <div v-if="event.extra && event.user" class="events-img-list">
                                <div
                                    v-for="img in event.extra"
                                    class="events-img-wrapper"
                                >
                                    <photoDetailsOpener
                                        v-if="img.image"
                                        :src="img.image"
                                        :photoId="img.id"
                                        :ownerId="event.user.id"
                                        :extra="event.extra"
                                        :isVideo="event.event_type == 22"
                                        class="events-img"
                                        :class="{
                                            'events-img-video':
                                                event.event_type == 22,
                                        }"
                                    >
                                    </photoDetailsOpener>
                                    <i v-else
                                        >{{
                                            event.event_type == 22
                                                ? $t("events.video")
                                                : $t("events.image")
                                        }}
                                        {{ $t("events.deletedUnavailable") }}
                                    </i>
                                </div>
                            </div>
                            <div v-else class="events-img-empty">
                                <i
                                    >{{
                                        event.event_type == 22
                                            ? $t("events.video")
                                            : $t("events.photos")
                                    }}
                                    {{ $t("events.deletedUnavailable") }}
                                </i>
                            </div>
                        </div>

                        <div v-if="event.event_type == 11">
                            <div class="user-item-subtitle">
                                {{ $t("events.friend") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>

                            <div class="user-item-subtitle">
                                {{ $t("events.addedPuzzle") }}
                            </div>

                            <div v-if="event.extra && event.extra[0] && event.extra[0].image" class="events-img-wrapper">
                                <img
                                    :src="event.extra[0].image"
                                    alt="Puzzle"
                                    style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                        object-position: center;
                                    "
                                />
                            </div>
                            <div v-else class="events-img-empty">
                                <i>{{ $t("events.photoDeleted") }}</i>
                            </div>
                        </div>

                        <div v-if="event.event_type == 12">
                            <div class="user-item-subtitle">
                                {{ $t("events.friend") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>
                            <div v-if="event.extra" class="user-item-subtitle">
                                {{ $t("events.wonPrize") }}

                               

                                {{ $t("events.photolentaFor") }}

                                {{ event.extra.count }}

                                {{ $t("events.combinationPhoto") }}
                                <!-- {{ event.extra.combination }} -->
                                {{
                                    getCombinationTranslation(
                                        event.extra.combination
                                    )
                                }}
                            </div>
                            <div v-if="event.extra" class="events-img-list">
                                <div v-for="img in event.extra" class="events-img-wrapper">
                                    <photoDetailsOpener v-if="img.image" :src="img.image" :photoId="img.id"
                                        :ownerId="event.user.id" :extra="event.extra" class="events-img">
                                    </photoDetailsOpener>
                                </div>
                            </div>
                            <!-- <div v-else class="events-img-empty">
                                <i>{{ $t("events.imagesDeletedUnavailable") }}</i>
                            </div> -->
                        </div>

                        <div v-if="event.event_type == 13">
                            <div class="user-item-subtitle">
                                {{ $t("events.friend") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>
                            <div v-if="event.extra" class="user-item-subtitle">
                                {{ $t("events.wonRouletteNumber") }}
                                {{ event.extra.winning_number }}
                                {{ $t("events.andWon") }}
                                {{ event.extra.prize.name }}
                                <img
                                    :src="event.extra.prize.image"
                                    alt="Photo"
                                    style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                        object-position: center;
                                    "
                                />
                            </div>
                        </div>

                        <div v-if="event.event_type == 14">
                            <div class="user-item-subtitle">
                                {{ $t("events.friend") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>
                            <div v-if="event.extra" class="user-item-subtitle">
                                {{ $t("events.hasWonVictory") }}
                                <!-- {{ event.extra.game }} -->
                                {{ getGameTranslation(event.extra.game) }}
                                {{ $t("events.andWon") }}
                                {{ event.extra.prize }}
                            </div>
                        </div>

                        <!-- Не будет данного эвента -->
                        <!-- <div v-if="event.event_type == 15">
                            <div class="user-item-subtitle">
                                {{ $t("events.friend") }}
                                <router-link :to="'/profile/' + event.user.id" class="user-item-title" target="_self">
                                    {{ event.user.name }}
                                </router-link>
                            </div>
                            <div class="user-item-subtitle">
                                {{ $t("events.hasWonVictory") }}

                                {{ $t("events.asResult") }}
                            </div>
                        </div> -->

                        <div v-if="event.event_type == 16">
                            <div v-if="event.extra" class="user-item-subtitle">
                                {{ $t("events.youWonPrize") }}

                                {{
                                    event.extra.prize &&
                                    typeof event.extra.prize === "object"
                                        ? event.extra.prize.name
                                        : event.extra.prize
                                }}

                                {{ $t("events.photolentaFor") }}

                                {{ event.extra.count }}

                                {{ $t("events.combinationPhoto") }}
                                <!-- {{ event.extra.combination }} -->
                                {{
                                    getCombinationTranslation(
                                        event.extra.combination
                                    )
                                }}
                            </div>
                            <div
                                v-if="getMordaLentaPrizeImage(event.extra)"
                                class="events-img-wrapper"
                            >
                                <img
                                    :src="getMordaLentaPrizeImage(event.extra)"
                                    alt="Prize"
                                    style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                        object-position: center;
                                    "
                                />
                            </div>
                        </div>

                        <div v-if="event.event_type == 17">
                            <div class="user-item-subtitle">
                                {{ $t("events.friend") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>
                            <div class="user-item-subtitle">
                                {{ $t("events.addedNewVideos") }}
                            </div>
                        </div>

                        <div v-if="event.event_type == 18">
                            <div class="user-item-subtitle">
                                {{ $t("events.friend") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>
                            <div class="user-item-subtitle">
                                {{ $t("events.commentYourVideo") }}
                            </div>
                            <div v-if="event.extra && event.extra.video && event.extra.video.image" class="events-img-wrapper">
                                <img
                                    :src="event.extra.video.image"
                                    alt="Photo"
                                    style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                        object-position: center;
                                    "
                                />
                            </div>
                            <div v-else class="events-img-empty">
                                <i>{{ $t("events.videoDeleted") }}</i>
                            </div>
                        </div>

                        <div v-if="event.event_type == 19">
                            <div class="user-item-subtitle">
                                {{ $t("events.friend") }}
                                <router-link
                                    v-if="event.user"
                                    :to="'/profile/' + event.user.id"
                                    class="user-item-title"
                                    target="_self"
                                >
                                    {{ event.user.name }}
                                </router-link>
                                <span v-else class="user-item-title">{{ $t("events.unknownUser") }}</span>
                            </div>
                            <div class="user-item-subtitle">
                                {{ $t("events.likedYourVideo") }}
                            </div>
                        </div>

                        <div v-if="event.event_type == 20">
                            <div class="user-item-subtitle">
                                {{ $t("events.photoModerated") }}
                            </div>
                        </div>

                        <div class="user-item-bottom">
                            {{ getVerbalDate(event.time * 1000) }}
                        </div>
                    </div>

                    <div v-if="event.event_type == 4" class="user-item-right">
                        <eventFriendButton :event="event"></eventFriendButton>
                    </div>

                    <div
                        v-if="
                            event.event_type == 6 &&
                            event.user
                        "
                        class="user-item-right"
                    >
                        <button
                            @click="
                                $modal.show('gifts-list', { id: event.user.id })
                            "
                            class="button"
                        >
                            <span>
                                {{ $t("events.toGiveReturn") }}
                            </span>
                        </button>
                    </div>

                    <div
                        @click="removeEvent(event.id)"
                        class="user-item-remove"
                    >
                        <span>{{ $t("myPuzzles.delete") }}</span>
                    </div>
                </div>
                <div v-if="moreLoader" class="button-loader"></div>
            </div>
            <div v-else class="text">
                {{ $t("events.theListEventsEmpty") }}
            </div>
        </div>
    </section>
    <section v-else class="no-auth">
        {{ $t("auth.noAuth") }}
        <router-link class="link" tag="a" :to="{ name: 'home' }"
            >{{ $t("auth.noAuthLink") }}
        </router-link>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import { formatDateTime } from "@/mixins/formatDateTime";
import { toggleTabs } from "@/mixins/toggleTabs";
import { declineNouns } from "@/mixins/declineNouns";
import { observeListEnd } from "@/mixins/observeListEnd";
import redirectButton from "@/components/Buttons/Redirect";
import photoDetailsOpener from "@/components/Blocks/PhotoDetailsOpener";
import eventFriendButton from "@/components/Blocks/EventFriendButton";
// import {getGiftImgUrl} from '@/mixins/getGiftImgUrl';
import Vue from "vue";
Vue.component("redirectButton", redirectButton);
Vue.component("photoDetailsOpener", photoDetailsOpener);

export default {
    name: "Events",
    props: {
        i18n: Object,
    },
    components: {
        redirectButton,
        eventFriendButton,
        photoDetailsOpener,
    },
    mixins: [
        formatDateTime,
        toggleTabs,
        declineNouns,
        observeListEnd,
        // getGiftImgUrl
    ],
    data() {
        return {
            pageLoader: true,
            moreLoader: false,
            removeLoader: false,
            moreIndex: 0,
            observer: null,
        };
    },
    computed: {
        ...mapGetters({
            userIsEmpty: "user/isEmpty",
            user: "user/fetchUser",
            eventsIsEmpty: "events/isEmpty",
            events: "events/fetchEvents",
            next: "events/fetchEventsNext",
            pageSize: "events/fetchEventsPageSize",
            init: "init/fetchInit",
            newCount: "events/fetchEventsNewCount",
        }),
    },
    created() {
        this.getEvents();
        this.observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting === true) {
                    this.showMore();
                }
            },
            { threshold: [0] }
        );
    },
    methods: {
        getGameTranslation(game) {
            switch (game) {
                case "Да-нет":
                    return this.$t("games.yesNo");
                case "Кручу-верчу":
                    return this.$t("games.twistingTurning");
                case "Дурак на раздевание":
                    return this.$t("games.theUndressingFool");
                default:
                    return game;
            }
        },
        getCombinationTranslation(combination) {
            switch (combination) {
                case "Фул-хаус":
                    return this.$t("lentaGifts.full_house");
                case "Стрит-флеш":
                    return this.$t("lentaGifts.straight_flush");
                case "Роял-флеш":
                    return this.$t("lentaGifts.royal_flush");
                case "Каре":
                    return this.$t("lentaGifts.four_of_kind");
                case "Флеш":
                    return this.$t("lentaGifts.flush");
                case "Стрит":
                    return this.$t("lentaGifts.straight");
                case "Две пары":
                    return this.$t("lentaGifts.two_pairs");
                default:
                    return combination;
            }
        },
        getMordaLentaPrizeImage(extra) {
            if (!extra || !extra.prize || typeof extra.prize !== "object") {
                return null;
            }
            return extra.prize.image || null;
        },
        getEvents() {
            this.$store
                .dispatch("events/get")
                .then(() => {
                    console.log("Events loaded:", this.events);
                    // Логирование событий с проблемными данными
                    this.events.forEach((event, index) => {
                        // Проверяем наличие пользователя
                        if (!event.user && event.event_type !== 7 && event.event_type !== 16 && event.event_type !== 20) {
                            console.warn(`Event ${index} (type ${event.event_type}): event.user is null`, event);
                        }
                        
                        // Проверяем extra
                        if (!event.extra) {
                            console.warn(`Event ${index} (type ${event.event_type}): extra is null`, event);
                        } else if (event.extra && !event.extra.image && [1, 6, 7, 9].includes(event.event_type)) {
                            console.warn(`Event ${index} (type ${event.event_type}): extra.image is missing`, event);
                        } else if (event.event_type === 3 && (!event.extra.photo || !event.extra.photo.image)) {
                            console.warn(`Event ${index} (type ${event.event_type}): extra.photo.image is missing`, event);
                        } else if (event.event_type === 18 && (!event.extra.video || !event.extra.video.image)) {
                            console.warn(`Event ${index} (type ${event.event_type}): extra.video.image is missing`, event);
                        }
                    });
                    this.pageLoader = false;
                    this.updateMoreIndex();
                    this.observeListEnd("element");
                    this.decrementCounter();
                })
                .catch((error) => {
                    console.error("Error loading events:", error);
                    this.pageLoader = false;
                });
        },
        decrementCounter() {
            if (this.init.counters.events == 0) {
                return;
            }
            this.$store.dispatch("init/setCounters", {
                counter: "events",
                increment: true,
                count: -1 * this.newCount,
            });
        },
        updateMoreIndex() {
            this.moreIndex = this.events.length - 2;
        },
        showMore() {
            if (this.next) {
                this.moreLoader = true;
                this.$store
                    .dispatch("events/getNext")
                    .then(() => {
                        console.log("More events loaded:", this.events);
                        this.decrementCounter();
                        this.observeListEnd("element", false, true, true);
                        this.moreLoader = false;
                    })
                    .catch((error) => {
                        console.error("Error loading more events:", error);
                        this.moreLoader = false;
                    });
            } else {
                this.observeListEnd("element", false, true);
            }
        },
        removeEvent(id) {
            if (this.removeLoader) {
                return;
            }
            this.removeLoader = true;
            this.$store
                .dispatch("events/remove", id)
                .then(() => {
                    this.removeLoader = false;
                })
                .catch(() => {
                    this.removeLoader = false;
                });
        },
        formatText({ id, text, event_type, user, time, viewed, extra }) {
            let html, src, photoId, ownerId, extraArr, comment, instanceText;
            let userLink =
                event_type <= 16 || event_type >= 22
                    ? '<redirectButton :pathname="pathname" :params="params" :html="linktext" class="user-item-title"></redirectButton></div><div class="user-item-subtitle">'
                    : "";
            switch (event_type) {
                case 1:
                    if (extra) {
                        src = extra.image;
                        photoId = extra.id;
                    }
                    ownerId = this.user.id;
                    html = text.format(userLink);
                    if (src) {
                        html +=
                            '<div class="events-img-wrapper"><photoDetailsOpener :src="src" :photoId="photoId" :ownerId="ownerId" class="events-img"></photoDetailsOpener></div>';
                    } else {
                        html += `<br><i>{{$t('events.photoDeleted')}}</i>`;
                    }
                    break;
                case 24:
                    if (extra) {
                        src = extra.image;
                        photoId = extra.id;
                    }
                    ownerId = this.user.id;
                    html = text.format(userLink);
                    if (src) {
                        //console.log(event_type);
                        html +=
                            '<div class="events-img-wrapper"><photoDetailsOpener :src="src" :photoId="photoId" :ownerId="ownerId" class="events-img events-img-video"></photoDetailsOpener></div>';
                    } else {
                        html += `<br><i>{{$t('events.videoProcessingDeleted')}}</i>`;
                    }
                    break;
                case 2:
                case 11:
                    if (extra) {
                        html = text.format(userLink, "«" + extra.title + "»");
                    } else {
                        html = text.format(
                            userLink,
                            `<i>{{$t('events.historyDeleted')}}</i>`
                        );
                    }

                    break;
                case 3:
                    if (extra && extra.photo) {
                        src = extra.photo.image;
                        photoId = extra.photo.id;
                    }
                    ownerId = this.user.id;
                    html = text.format(userLink, "", "");

                    if (src) {
                        html +=
                            '<br><br><div class="events-img-wrapper events-comment-wrapper"><photoDetailsOpener :src="src" :photoId="photoId" :ownerId="ownerId" :isVideo="false" class="events-img"></photoDetailsOpener></div>';
                    } else {
                        html += `<br><i>{{$t('events.photoDeleted')}}</i>`;
                    }
                    comment =
                        extra && extra.comment
                            ? "«" + extra.comment.text + "»"
                            : `<i>{{$t('events.commentDeleted')}}</i>`;
                    html += comment;
                    break;
                case 23:
                    if (extra && extra.video) {
                        src = extra.video.image;
                        photoId = extra.video.id;
                    }
                    ownerId = this.user.id;
                    html = text.format(userLink, "", "");

                    if (src) {
                        html +=
                            '<br><br><div class="events-img-wrapper events-comment-wrapper"><photoDetailsOpener :src="src" :photoId="photoId" :ownerId="ownerId" :isVideo="true" class="events-img events-img-video"></photoDetailsOpener></div>';
                    } else {
                        html += `<br><i>{{$t('events.videoProcessingDeleted')}}</i>`;
                    }
                    comment =
                        extra && extra.comment
                            ? "«" + extra.comment.text + "»"
                            : `<i>{{$t('events.commentDeleted')}}</i>`;
                    html += comment;
                    break;
                case 4:
                case 5:
                case 9:
                case 10:
                case 12:
                case 22:
                    html = text.format(userLink);
                    break;
                case 6:
                    html = text.format(userLink);
                    if (extra) {
                        for (let i in extra) {
                            src = extra[i].image;
                            photoId = extra[i].id;
                            ownerId = this.user.id;
                            if (src) {
                                html +=
                                    '<div class="events-img-wrapper"><photoDetailsOpener :src="src" :photoId="photoId" :ownerId="ownerId" class="events-img"></photoDetailsOpener></div>';
                            } else {
                                html += `<br><i>{{$t('events.imageDeleted')}}</i>`;
                            }
                        }
                    } else {
                        html += `<br><i>{{$t('events.imageDeleted')}}</i>`;
                    }
                    break;
                case 7:
                    let fromUser = user
                        ? userLink
                        : '<span class="user-item-title">аноним</span></div><div class="user-item-subtitle">';
                    html = text.format(fromUser, "");
                    break;
                case 8:
                    html = text.format(userLink, "");
                    break;
                case 13:
                    if (extra) {
                        html = text.format(
                            userLink,
                            "<b>" + extra.prize.name + "</b>",
                            extra.count,
                            "«" + extra.combination + "»"
                        );
                    } else {
                        html = `{{$t("login.error")}}`;
                    }
                    break;
                case 14:
                    if (extra) {
                        html = text.format(
                            userLink,
                            extra.winning_number,
                            "<b>" + extra.prize.name + "</b>"
                        );
                    } else {
                        html = `{{$t("login.error")}}`;
                    }
                    break;

                case 15:
                    if (extra) {
                        html = text.format(
                            userLink,
                            "игре " + "«" + extra.game + "»",
                            "<b>" +
                                extra.prize +
                                " " +
                                this.declineNouns(extra.prize, [
                                    $t("photoDetails.zarik"),
                                    $t("photoDetails.zarika"),
                                    $t("photoDetails.zarikov"),
                                ]) +
                                "</b>"
                        );
                    } else {
                        html = `{{$t("login.error")}}`;
                    }
                    break;
                case 16:
                    if (extra) {
                        html = text.format(
                            userLink,
                            "«" + extra.title + "»",
                            "«" + extra.result + "»"
                        );
                    } else {
                        html = `{{$t("login.error")}}`;
                    }
                    break;
                case 17:
                    if (extra) {
                        html = '<div class="user-item-subtitle">';
                        html += text.format(
                            "<b>" + extra.prize.name + "</b>",
                            extra.count,
                            "«" + extra.combination + "»"
                        );
                        html += "</div>";
                    } else {
                        html = `{{$t("login.error")}}`;
                    }
                    break;
                case 18:
                    if (extra) {
                        html = '<div class="user-item-subtitle">';
                        html += text.format(
                            extra.winning_number,
                            "<b>" + extra.prize.name + "</b>"
                        );
                        html += "</div>";
                    } else {
                        html = `{{$t("login.error")}}`;
                    }
                    break;
                case 19:
                    if (extra) {
                        html = '<div class="user-item-subtitle">';
                        html += text.format(
                            "игре " + "«" + extra.game + "»",
                            "<b>" +
                                extra.prize +
                                " " +
                                this.declineNouns(extra.prize, [
                                    $t("photoDetails.zarik"),
                                    $t("photoDetails.zarika"),
                                    $t("photoDetails.zarikov"),
                                ]) +
                                "</b>"
                        );
                        html += "</div>";
                    } else {
                        html = `{{$t("login.error")}}`;
                    }
                    break;
                case 20:
                    return {};
                // if (extra) {
                //     let success = extra.success
                //         ? $t("events.successfully")
                //         : $t("events.failed");
                //     html =
                //         '<div class="user-item-subtitle">' +
                //         text +
                //         " на <b>" +
                //         extra.amount +
                //         " " +
                //         this.declineNouns(extra.amount, [
                //             $t("photoDetails.zarik"),
                //             $t("photoDetails.zarika"),
                //             $t("photoDetails.zarikov"),
                //         ]) +
                //         "</b> " +
                //         success +
                //         "</div>";
                // } else {
                //     html = `{{$t("login.error")}}`;
                // }
                // break;
                default:
                    html = `{{$t("events.eventUnavailable")}}`;
            }

            return {
                template: "<div><div>" + html + "</div></div>",
                props: {
                    pathname: {
                        type: null,
                        default: () => {
                            return "profile";
                        },
                    },
                    params: {
                        type: null,
                        default: () => {
                            return {
                                id: user ? user.id : "",
                            };
                        },
                    },
                    linktext: {
                        type: null,
                        default: () => {
                            return user ? user.name : "";
                        },
                    },
                    src: {
                        type: null,
                        default: () => {
                            return src;
                        },
                    },
                    photoId: {
                        type: null,
                        default: () => {
                            return photoId;
                        },
                    },
                    ownerId: {
                        type: null,
                        default: () => {
                            return ownerId;
                        },
                    },
                },
            };
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_tabs";
</style>

<style lang="scss">
@import "~@/assets/styles/pages/_events";
</style>
